module.exports = __webpack_public_path__ + "static/media/sfl_7.8d428334.jpg";